import styled from 'styled-components'
import { font } from 'lib/core/resources/helpers/styled'

export const Wrapper = styled.div`
  p {
    margin: 0;
    font-size: 20px;
  }

  .wrapper {
    margin: 30px 0;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;

    .item {
      width: 45%;
      min-width: 200px;
      margin: 10px 5px;

      img {
        max-width: 100%;
        max-height: 135px;
        margin: auto;
        display: block;
      }

      span {
        font: ${font('default', 'medium', '18px/1.3')};
        margin: 15px 0 10px;
        display: block;
        height: 48px;
        color: ${props => props.theme.palette.general.strong};
      }

      .button {
        ${props => props.theme.css.buttonPrimary};
      }
    }
  }

  a {
    color: ${props => props.theme.palette.primary.alphaDark};
  }
`
